/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Export_CsvInputs */

const en_admin_statistics_export_csv = /** @type {(inputs: Admin_Statistics_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export as CSV`)
};

const de_admin_statistics_export_csv = /** @type {(inputs: Admin_Statistics_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als CSV exportieren`)
};

/**
* | output |
* | --- |
* | "Export as CSV" |
*
* @param {Admin_Statistics_Export_CsvInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_export_csv = /** @type {((inputs?: Admin_Statistics_Export_CsvInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Export_CsvInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_export_csv(inputs)
	return en_admin_statistics_export_csv(inputs)
});